// extracted by mini-css-extract-plugin
module.exports = {"clientReferralWrapper":"ClientReferral_clientReferralWrapper__16HkT","title":"ClientReferral_title__vpanU","itemText":"ClientReferral_itemText__31_f4"};